(function () {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isTouch = window.matchMedia("(hover: none), (pointer: coarse)").matches;
  if (prefersReducedMotion || isTouch || typeof Lenis === "undefined") return;

  const lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // Pause Lenis while the nav drawer or cart drawer locks the page.
  const lockObserver = new MutationObserver(() => {
    const locked =
      document.body.classList.contains("nav-open") ||
      document.body.classList.contains("cart-open");
    if (locked) {
      lenis.stop();
    } else {
      lenis.start();
    }
  });
  lockObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });

  // Same-page anchors go through Lenis; CSS scroll-margin doesn't apply to
  // programmatic scrolls, so offset for the sticky header manually.
  const ANCHOR_OFFSET = -104;

  document.addEventListener("click", (event) => {
    const link = event.target.closest ? event.target.closest('a[href*="#"]') : null;
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch {
      return;
    }
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
    if (!url.hash || url.hash === "#") return;

    const target = document.querySelector(url.hash);
    if (!target) return;

    event.preventDefault();
    history.pushState(null, "", url.hash);
    lenis.scrollTo(target, { offset: ANCHOR_OFFSET });
  });
})();
